// «Отчёт по критериям» (E4, #1342) — отчёт #866 своим экраном. Вход — из
// карточки «Критерии компании» единого дашборда, где вкладки «Критерии»
// прежних дашбордов нет; выбранный критерий приходит параметром адреса.
import { useCallback } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ListChecks } from 'lucide-react';
import { DashboardBody } from '@/components/layout/DashboardBody';
import { Breadcrumb, BreadcrumbItem } from '@/components/navigation/breadcrumb';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { CriteriaReportView } from '@/components/analytics/criteria/CriteriaReportView';
import {
  parseCriteriaReportSearch,
  type CriteriaReportSearch,
} from '@/components/analytics/criteria/criteria-report-search';

function CriteriaReportPage() {
  const { t } = useTranslation('dashboard');
  useDocumentTitle(t('criteriaReportPage.title'));
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const onSearchChange = useCallback(
    (patch: Partial<CriteriaReportSearch>) =>
      void navigate({ search: (previous) => ({ ...previous, ...patch }), replace: true }),
    [navigate]
  );

  return (
    <DashboardBody
      title={t('criteriaReportPage.title')}
      subtitle={t('criteriaReportPage.subtitle')}
      icon={ListChecks}
      breadcrumbs={
        <Breadcrumb>
          <BreadcrumbItem href="/">Aelo</BreadcrumbItem>
          <BreadcrumbItem href="/dashboard">
            {t('criteriaReportPage.breadcrumbParent')}
          </BreadcrumbItem>
          <BreadcrumbItem current>{t('criteriaReportPage.title')}</BreadcrumbItem>
        </Breadcrumb>
      }
    >
      <CriteriaReportView search={search} onSearchChange={onSearchChange} />
    </DashboardBody>
  );
}

export const Route = createFileRoute('/analytics/criteria')({
  component: CriteriaReportPage,
  validateSearch: (search: Record<string, unknown>): CriteriaReportSearch =>
    parseCriteriaReportSearch(search),
});
